export default __webpack_public_path__ + "static/backgroundMainIntroResponsive-068e83471b752ae7029d2cb8e642ea85.svg";